import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";
import type { ErrorType } from "./custom-fetch";
import type { InvoiceDetail } from "./generated/api.schemas";

export const createDepositInvoice = async (parentInvoiceId: number): Promise<InvoiceDetail> =>
  customFetch<InvoiceDetail>(`/api/invoices/${parentInvoiceId}/deposit-invoice`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });

export const useCreateDepositInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: UseMutationOptions<InvoiceDetail, TError, { parentInvoiceId: number }, TContext>
) => {
  return useMutation<InvoiceDetail, TError, { parentInvoiceId: number }, TContext>({
    mutationFn: ({ parentInvoiceId }) => createDepositInvoice(parentInvoiceId),
    ...options,
  });
};
